const namespace = 'Home';

export const SET_FAQ = `${namespace}/SET_FAQ`;
